import {
  Box,
  Button,
  Divider,
  Grid2,
  Grow,
  ImageListItem,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import PDImage from "./PDImage";
import { blueGrey, grey } from "@mui/material/colors";
import ClearIcon from "@mui/icons-material/Clear";
import ClaimRowChip from "./ClaimRowChip";
import { Info, VisibilityOff } from "@mui/icons-material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const fullModalStyle = {
  position: "fixed",
  // top: "50%",
  // left: "50%",
  // transform: "translate(-50%, -50%)",
  width: "100%",
  height: "100%",
  // maxWidth: "1600px",
  bgcolor: "background.default",
  border: "1px solid #000",
  borderRadius: 0,
  boxShadow: 10,
  pb: 3,
  pt: 0,
  px: 0,
  mt: 8,
  overflow: "scroll",
  mb: 2,
};

function AdditionalInfo({ text, value, direction = "column" }) {
  return (
    <Stack
      spacing={direction === "column" ? 0 : 0.25}
      direction={direction}
      alignItems={"center"}
      sx={{ bgcolor: grey[300], borderRadius: 1, px: 0.5 }}
    >
      <Typography variant="caption">{text}</Typography>
      <Typography sx={{ fontWeight: 700 }}>{value}</Typography>
    </Stack>
  );
}

function PDDocPreview({ pretty_date, current_task, task_index }) {
  const [openFullModal, setOpenFullModal] = React.useState(false);
  const [selected_task_num, setSelectedTaskNum] = React.useState(null);

  const docFullPath1 = current_task.skip_page == "first" ? current_task.images[1][0] : current_task.images[0][0];
  var docFileName1 = docFullPath1.split('/');
  const docId1 = docFileName1[docFileName1.length - 1].split('_')[0];

  const docFullPath2 = current_task.skip_page == "first" ? current_task.images[1][1] : current_task.images[0][1];
  var docFileName2 = docFullPath2.split('/');
  const docId2 = docFileName2[docFileName2.length - 1].split('_')[0];

  

  const handleImageClick = (current_task_num) => {
    setOpenFullModal(true);
    setSelectedTaskNum(current_task_num);
  };

  const handleCloseImage = () => {
    setOpenFullModal(false);
    setSelectedTaskNum(null);
  };

  const [showInfo, setShowInfo] = React.useState(false);

  const handleToggleInfo = () => {
    setShowInfo((prev) => !prev);
  };

  return (
    <React.Fragment>
      <ImageListItem
        onClick={() => handleImageClick(task_index)}
        sx={{
          p: 0,
          m: 1,
          my: 0.5,
        }}
      >
        <Stack direction={"row"} spacing={1}>
          {/* <ClaimRowChip chip_width={115} value={current_task.num_pages_compared} text={`page ${current_task.num_pages_compared > 1 ? "s" : ""} compared`}/> */}
          <Typography sx={{ pb: 1, fontSize: 12, fontWeight: "bold" }}>
            Similar Comparison {task_index + 1}:
          </Typography>
          <Typography sx={{ pb: 1, fontSize: 12, fontWeight: 400 }}>
            {current_task.num_pages_compared} pg
            {current_task.num_pages_compared > 1 ? "s" : null} compared
          </Typography>
          {current_task.skip_page !== "none" ? (
            <Typography
              sx={{ pb: 1, fontSize: 12, fontWeight: 400, color: grey[700] }}
            >
              (Skipped {current_task.skip_page} page)
            </Typography>
          ) : null}
        </Stack>

        <PDImage
          img1_path={
            current_task.skip_page === "first"
              ? current_task.images[1][0]
              : current_task.images[0][0]
          }
          img2_path={
            current_task.skip_page === "first"
              ? current_task.images[1][1]
              : current_task.images[0][1]
          }
          task_index={task_index + 1}
        />
        {/* <Typography align="center" sx={{ border: 0, fontWeight: 700, pt: 0.5 }}>
          *Click above to view all pages{" "}
          {current_task.skip_page !== "none" ? "including skipped page" : null}*
        </Typography> */}
      </ImageListItem>

      <Modal
        open={openFullModal}
        onClose={handleCloseImage}
        aria-labelledby="enlarged-image-modal"
        aria-describedby="enlarged-image-modal-description"
      >
        <Box sx={fullModalStyle}>
          <Grid2
            container
            sx={{
              border: 1,
              width: "100%",
              pb: 1,
              p: 1,
              alignItems: "center",
              position: "sticky",
              top: 0,
              backgroundColor: "background.paper", // To ensure the background is consistent
              zIndex: 5, // Ensure it stays on top of the rest of the content
              borderBottom: "1px solid #ddd", // Optional: add a bottom border for better separation
              mb: 0,
            }}
          >
            <Grid2 size={1.5}>
              <Stack direction={"row"} alignItems={"center"}>
                <Button
                  variant="contained"
                  onClick={handleCloseImage}
                  sx={{
                    borderRadius: 3,
                    textTransform: "unset",
                    backgroundColor: "primary.main",
                  }}
                  startIcon={<ClearIcon />}
                >
                  CLOSE
                </Button>
                <Typography
                  sx={{ p: 0, pb: 0, ml: 1, fontSize: 14, fontWeight: "bold" }}
                >
                  Similar Comparison: {selected_task_num + 1}
                </Typography>
              </Stack>
            </Grid2>
            <Grid2 align={"center"} size={9} sx={{ border: 0 }}>
              <Stack direction={"column"} alignItems={"center"} spacing={0}>
                <Button
                  variant="contained"
                  sx={{
                    borderRadius: 3,
                    textTransform: "unset",
                    backgroundColor: "secondary.main",
                    mb: showInfo ? 1 : 0,
                  }}
                  startIcon={showInfo ? <VisibilityOff /> : <Info />}
                  onClick={handleToggleInfo}
                >
                  {showInfo ? "Hide Info" : "Additional Info"}
                </Button>
                {showInfo && (
                  <Stack spacing={1.5} direction={"row"}>
                    <AdditionalInfo text={"Date:"} value={pretty_date} />
                    <AdditionalInfo
                      text={"Total Pages:"}
                      value={current_task.images.length}
                    />
                    <AdditionalInfo
                      text={"Skip Page:"}
                      value={current_task.skip_page}
                    />

                    {/* <AdditionalInfo text={"Model:"} value={"<MODEL>"} /> */}

                    <Stack spacing={0.25}>
                      <AdditionalInfo
                        direction={"row"}
                        text={"Doc CD1 [left]:"}
                        value={current_task.doc_cd1}
                      />
                      <AdditionalInfo
                        direction={"row"}
                        text={"Doc CD2 [right]:"}
                        value={current_task.doc_cd2}
                      />
                    </Stack>

                    <Stack spacing={0.25}>
                      <AdditionalInfo
                        direction={"row"}
                        text={"DocID1 [left]:"}
                        value={docId1}
                      />
                      <AdditionalInfo
                        direction={"row"}
                        text={"DocID2 [right]:"}
                        value={docId2}
                      />
                    </Stack>
                  </Stack>
                )}
              </Stack>
            </Grid2>
            <Grid2 size={1.5} />
          </Grid2>
          {current_task.images.map((image_pair, cur_img_index) => (
            <React.Fragment key={cur_img_index}>
              <PDImage
                key={cur_img_index}
                bottom_margin={3}
                img1_path={image_pair[0]}
                watermark_img1={image_pair[1] === "skip"}
                blank_img1={image_pair[0] === "skip"}
                img2_path={image_pair[1]}
                watermark_img2={image_pair[0] === "skip"}
                blank_img2={image_pair[1] === "skip"}
                task_index={task_index + 1}
              />
              <Typography
                align="center"
                sx={{
                  borderBottom: 1,
                  borderColor: grey[300],
                  color: grey[800],
                  fontWeight: 700,
                  py: 0.5,
                }}
              >
                Page {cur_img_index + 1}
              </Typography>
            </React.Fragment>
          ))}
          <Typography
            align="center"
            sx={{
              height: 100,
              border: 0,
              color: grey[400],
              fontWeight: 700,
              mt: 1,
            }}
          >
            End of pages
          </Typography>
        </Box>
      </Modal>
    </React.Fragment>
  );
}

export default PDDocPreview;
